
export const PRESET_NAME_LENGTH = 8;

export const PRESET_COMMAND_TYPE = 'Command Type';
export const PRESET_PRESET_NUMBER = 'Preset Number';
export const PRESET_PRESET_NAME_0 = 'Preset Name 0';
export const PRESET_PRESET_NAME_1 = 'Preset Name 1';
export const PRESET_PRESET_NAME_2 = 'Preset Name 2';
export const PRESET_PRESET_NAME_3 = 'Preset Name 3';
export const PRESET_PRESET_NAME_4 = 'Preset Name 4';
export const PRESET_PRESET_NAME_5 = 'Preset Name 5';
export const PRESET_PRESET_NAME_6 = 'Preset Name 6';
export const PRESET_PRESET_NAME_7 = 'Preset Name 7';
export const PRESET_DEV_A_LSB_0__7 = 'Dev A LSB 0..7';
export const PRESET_DEV_A_MSB_9__8 = 'Dev A MSB 9..8';
export const PRESET_DEV_B_LSB_0__7 = 'Dev B LSB 0..7';
export const PRESET_DEV_B_MSB_9__8 = 'Dev B MSB 9..8';
export const PRESET_DEV_C_LSB_0__7 = 'Dev C LSB 0..7';
export const PRESET_DEV_C_MSB_9__8 = 'Dev C MSB 9..8';
export const PRESET_DEV_D_LSB_0__7 = 'Dev D LSB 0..7';
export const PRESET_DEV_D_MSB_9__8 = 'Dev D MSB 9..8';
export const PRESET_TEMPO_LSB_0__7 = 'Tempo LSB 0..7';
export const PRESET_TEMPO_MSB = 'Tempo MSB';
export const PRESET_UTIL_STATE_1 = 'Util State 1';
export const PRESET_UTIL_STATE_2 = 'Util State 2';

export type PresetDataItem = {
    index?: number,
    value_max?: number,
    value_def?: number,
    text?: string,
    padding?: boolean
};

export const PRESET_DATA : { [name: string]: PresetDataItem } = {
    [PRESET_COMMAND_TYPE]: {index: 4, value_max: 125, text: '“0x7D” = Load Preset via Sysex'},
    [PRESET_PRESET_NUMBER]: {index: 5, value_max: 99, text: 'Preset number to store, maximum 99'},
    'padding 6': {index: 6, value_max: 0, text: '', padding: true},
    'padding 7': {index: 7, value_max: 0, text: '', padding: true},
    [PRESET_PRESET_NAME_0]: {index: 8, value_max: 127, text: 'Preset Name stored as ASCII bytes in order. Example preset “myPreset” would be stored'},
    [PRESET_PRESET_NAME_1]: {index: 9, value_max: 127, text: '0 = 0x6D, 1 = 0x79, 2 = 0x50, 3 = 0x72, 4 = 0x65, 5 = 0x72, 6 = 0x65, 7 = 0x74'},
    [PRESET_PRESET_NAME_2]: {index: 10, value_max: 127, text: ''},
    [PRESET_PRESET_NAME_3]: {index: 11, value_max: 127, text: ''},
    [PRESET_PRESET_NAME_4]: {index: 12, value_max: 127, text: ''},
    [PRESET_PRESET_NAME_5]: {index: 13, value_max: 127, text: ''},
    [PRESET_PRESET_NAME_6]: {index: 14, value_max: 127, text: ''},
    [PRESET_PRESET_NAME_7]: {index: 15, value_max: 127, text: ''},
    [PRESET_DEV_A_LSB_0__7]: {index: 16, value_max: 127, text: 'Lower 7 bits of program number to send'},
    [PRESET_DEV_A_MSB_9__8]: {index: 17, value_max: 7, text: 'Upper 2 bits of program number to send, Bypass state of device. B00000B98'},
    'padding 18': {index: 18, value_max: 0, text: '', padding: true},
    [PRESET_DEV_B_LSB_0__7]: {index: 19, value_max: 127, text: 'Lower 7 bits of program number to send'},
    [PRESET_DEV_B_MSB_9__8]: {index: 20, value_max: 7, text: 'Upper 2 bits of program number to send, Bypass state of device. B00000B98'},
    'padding 21': {index: 21, value_max: 0, text: '', padding: true},
    [PRESET_DEV_C_LSB_0__7]: {index: 22, value_max: 127, text: 'Lower 7 bits of program number to send'},
    [PRESET_DEV_C_MSB_9__8]: {index: 23, value_max: 7, text: 'Upper 2 bits of program number to send, Bypass state of device. B00000B98'},
    'padding 24': {index: 24, value_max: 0, text: '', padding: true},
    [PRESET_DEV_D_LSB_0__7]: {index: 25, value_max: 127, text: 'Lower 7 bits of program number to send'},
    [PRESET_DEV_D_MSB_9__8]: {index: 26, value_max: 7, text: 'Upper 2 bits of program number to send, Bypass state of device. B00000B98'},
    'padding 27': {index: 27, value_max: 0, text: '', padding: true},
    [PRESET_TEMPO_LSB_0__7]: {index: 28, value_max: 15, text: 'Lower 7 bits of tempo to send'},
    [PRESET_TEMPO_MSB]: {index: 29, value_max: 5, text: 'Upper 2 bits of tempo to send, 3 bits of tap division. B000DDD98'},
    [PRESET_UTIL_STATE_1]: {index: 30, value_max: 127, text: 'State of UTIL mode X and Y values, if set to TOGGLE, 6 bits. B00 YA YL YR XA XL XR'},
    [PRESET_UTIL_STATE_2]: {index: 31, value_max: 127, text: 'State of UTIL mode JACK, if set to toggle, 2 bits. B000000 RING TIP'},
    'padding 32': {index: 32, text: '', padding: true},
    'padding 33': {index: 33, text: '', padding: true},
    'padding 34': {index: 34, text: '', padding: true}
}

export const UTILITIES_NAMES: string[] = [];
UTILITIES_NAMES[100] = "Util X Left";
UTILITIES_NAMES[101] = "Util X Right";
UTILITIES_NAMES[102] = "Util X Alt";
UTILITIES_NAMES[103] = "Util Y Left";
UTILITIES_NAMES[104] = "Util Y Right";
UTILITIES_NAMES[105] = "Util Y Alt";

export function getDefaultPreset(): number[] {
    const a = new Array(Object.keys(PRESET_DATA).length);
    a.fill(0);
    // let index = 0;
    // for (const definition of Object.values(PRESET_DATA)) {
    //     a[index++] = 0;
    // }
    return a;
}

/**
 *
 * @param data Start at COMMAND byte.
 */
export function getPresetName(data: number[]): string {
    if (!data || (data.length < 12)) {
        //console.warn("getPresetName: invalid data", data);
        return '';
    }
    let name = '';
    const offset = 4;
    for (let i=0; i<8; i++) {
        let c = data[offset + i];
        name += String.fromCharCode(c);
    }
    return name;
}

export function nameToBytes(str: string, length: number = PRESET_NAME_LENGTH): number[] {
    let a = new Array(length);
    a.fill(0x20);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        // a[i] = str.charCodeAt(i) & 0xFF;
        let c = Math.min(str.charCodeAt(i));
        a[i] = c > 127 ? 0x20 : c;
        if (i === (length - 1)) break;   // max 8 chars
    }
    return a;
}